import { ModalHeader } from '@8x8/oxygen-modal'
import React from 'react'
import styled from 'styled-components'
import Badge from '@8x8/oxygen-badge'
import { hideDialog } from '~/actions/ui'

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const StyledBadge = styled(Badge)`
  color: ${({ theme }) => theme._neo.textColor10};
  background-color: ${({ theme }) => theme._neo.ui23};
  
  svg {
    fill: ${({ theme }) => theme._neo.textColor10};
  }
`

const StyledModalHeader = styled(ModalHeader)`
  & > div {
    white-space: normal;
    word-break: break-word;
  }
`

const Header = ({ title, badge, ...props }) => {
  const titleWithBadge = badge
    ? (
      <TitleContainer>
        {title}
        <StyledBadge>{badge}</StyledBadge>
      </TitleContainer>
      )
    : title

  return <StyledModalHeader {...props} title={titleWithBadge} />
}

Header.defaultProps = {
  onClose: hideDialog
}

export default Header
